import { detect } from 'detect-browser'

export const isSafariBrowser = () => {
    const info = detect()
    return info?.name === 'safari'
}
